import api from '~/utils/api'

export const state = () => ({
  formsSettings: {}
})

export const getters = {}

export const actions = {
  async requestBecomeAContributor(_, { payload, headerParams }) {
    try {
      const settings = {
        headers: { GoogleCaptchaResponseKey: headerParams.captchaKey }
      }
      await this.$ilAxios.post(
        api.leads.becomeAContributor(),
        payload,
        settings
      )
    } catch (e) {
      throw e
    }
  },
  async requestBecomeAContributorFileUpload(_, payload) {
    try {
      const { data } = await this.$ilAxios.post(
        api.leads.becomeAContributorFileUpload(),
        payload
      )
      return data
    } catch (e) {
      throw e
    }
  }
}

export const mutations = {}
